import { render } from "./Item.vue?vue&type=template&id=f1205d5a&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=f1205d5a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1205d5a"]])

export default __exports__